<template>
    <div style="margin: 0 auto;" :style="$q.platform.is.mobile ? 'width: 90vw;' : 'width: 60vw;'">
        <vue-plyr ref="plyr">
            <video autoplay muted playsinline webkit-playsinline ref="player" id="player">
            </video>
        </vue-plyr>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'dashjs'
import Hls from 'hls.js'
import Plyr from 'plyr'

export default {
    props: ['source', 'refresh'],
    data() {
        return {
            warn_user: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getResource() {
            return this.source.webcast_player_hls_playback_url
        },

        getType() {
            return 'application/x-mpegURL'
        },

        player () {
            return this.$refs.plyr.player
        }
    },

    methods: {
        enterfullscreen(e) {
            this.$emit('display', 'none')
        },

        exitfullscreen(e) {
            this.$emit('display', 'flex')
        },

        warnUser() {
            if (this.refresh) {
                this.$q.notify({
                    message: this.$t('transmission_started_no_video_refresh'),
                    position: 'top-left',
                    timeout: 4000,
                    icon: 'fas fa-redo-alt',
                    color: 'warning'
			    })
                setTimeout(() => {
                    this.warn_user = false
                }, 4000)
            }
        }
    },

    mounted () {
        this.player.on('enterfullscreen', (val) => this.enterfullscreen(val))
        this.player.on('exitfullscreen', (val) => this.exitfullscreen(val))

        this.warnUser()

        if (this.refresh) {
            this.warnUser = true
        }

        const video = this.$refs.player
        const hls = new Hls()
		hls.loadSource(this.getResource)
		hls.attachMedia(video)
    }
}
</script>

<style lang="stylus" scoped>
</style>
